// Time helpers — all display uses the browser's local timezone (= user timezone); API speaks UTC ISO.
export const MIN = 60 * 1000;
export const DAY_MS = 24 * 60 * MIN;

export function startOfDay(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
export function addDays(d, n) { const x = new Date(d); x.setDate(x.getDate() + n); return x; }
export function addMinutes(d, n) { return new Date(d.getTime() + n * MIN); }
export function startOfWeek(d) { const x = startOfDay(d); const wd = (x.getDay() + 6) % 7; return addDays(x, -wd); }
export function sameDay(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }
export function isoDate(d) { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; }
export function fromIsoDate(s) { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); }
export function minutesOf(d) { return d.getHours() * 60 + d.getMinutes(); }
export function atMinutes(day, min) { const x = startOfDay(day); x.setMinutes(min); return x; }
export function snap(min, step = 15) { return Math.round(min / step) * step; }
export function fmtHM(d) { return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`; }
export function fmtRange(s, e) { return `${fmtHM(s)} – ${fmtHM(e)}`; }
export function fmtDur(min) { const h = Math.floor(min / 60), m = min % 60; if (h && m) return `${h}h${String(m).padStart(2, "0")}`; if (h) return `${h}h`; return `${m} min`; }
export function fmtDayLong(d) { return d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" }); }
export function fmtDayShort(d) { return d.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric" }); }
export function fmtDateTime(iso) { if (!iso) return "—"; return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
export function toApi(d) { return d.toISOString(); }
export function localInputValue(d) { return `${isoDate(d)}T${fmtHM(d)}`; }
export const userTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

// Normalize API items (events + task blocks) into a single render shape.
export function normalizeItems(data) {
  const out = [];
  for (const e of data.events || []) {
    if (e.all_day) {
      out.push({ key: e.key, kind: "event", allDay: true, title: e.title, startDate: fromIsoDate(e.start_date),
        endDate: fromIsoDate(e.end_date || e.start_date), color: e.color, editable: e.editable, raw: e,
        transparency: e.transparency, status: e.status, provider: e.provider });
    } else {
      out.push({ key: e.key, kind: "event", allDay: false, title: e.title, start: new Date(e.start_utc), end: new Date(e.end_utc),
        color: e.color, editable: e.editable, raw: e, transparency: e.transparency, status: e.status, provider: e.provider });
    }
  }
  for (const b of data.task_blocks || []) {
    out.push({ key: b.key, kind: "task_block", allDay: false, title: b.task.title, start: new Date(b.scheduled_start), end: new Date(b.scheduled_end),
      editable: true, raw: b, locked: b.locked, done: b.status === "done" || b.task.status === "done", provider: "airtime" });
  }
  return out;
}
